import { ColorSchemeKey } from '@/ts/composables/useColorScheme';

interface ColorScheme {
  name: string;
  key: ColorSchemeKey;
}

interface ColorGroup {
  groupName: string;
  colorSchemes: ColorScheme[];
}

const COLOR_GROUPS: ColorGroup[] = [
  {
    groupName: 'LIGHT',
    colorSchemes: [
      { name: 'Red to Green', key: 'red-gray-green' },
      { name: 'Red to Blue', key: 'red-white-blue' },
      { name: 'Vanilla', key: 'vanilla' },
      { name: 'Mint', key: 'mint' },
      { name: 'Lavender', key: 'lavender' },
      { name: 'Cotton Candy', key: 'cotton-candy' },
      { name: 'Sunset', key: 'sunset' }
    ]
  },
  {
    groupName: 'DARK',
    colorSchemes: [
      { name: 'Red to Green', key: 'red-black-green' },
      { name: 'Blackberry', key: 'blackberry' }
    ]
  },
  {
    groupName: 'COLORBLIND',
    colorSchemes: [
      { name: 'Monochrome', key: 'monochrome' }
    ]
  }
];

export {
  COLOR_GROUPS
}

